import api from './api';
import { Task } from '../types';
import { mapReviewTask } from '../utils/idpEnquiry';

export const idpService = {
  getIntegration: async (): Promise<{ enabled: boolean }> => {
    const response = await api.get<{ enabled: boolean }>('/api/task-service/idp/integration');
    return response.data;
  },

  setEnabled: async (enabled: boolean): Promise<{ enabled: boolean }> => {
    const response = await api.put<{ enabled: boolean }>('/api/task-service/idp/integration', { enabled });
    return response.data;
  },

  listReview: async (): Promise<Task[]> => {
    const response = await api.get<Parameters<typeof mapReviewTask>[0][]>('/api/task-service/idp/review');
    return (response.data ?? []).map(mapReviewTask);
  },

  acceptReview: async (taskId: string, memberId: string): Promise<void> => {
    await api.post(`/api/task-service/idp/review/${taskId}/accept`, { memberId });
  },

  rejectReview: async (taskId: string): Promise<void> => {
    await api.post(`/api/task-service/idp/review/${taskId}/reject`);
  },

  importDocuments: async (taskId: string): Promise<void> => {
    await api.post(`/api/task-service/idp/tasks/${taskId}/documents`);
  },

  downloadAttachment: async (attachmentId: string, filename: string): Promise<void> => {
    const response = await api.get(`/api/task-service/idp/attachments/${attachmentId}`, { responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  },
};
